var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('SiteHeader',{attrs:{"bg":"false"}}),_c('home-callout'),_c('home-hero'),_c('home-what-we-do'),_c('home-about'),_c('case-studies-index',{attrs:{"standalone":"true"}}),_c('SiteFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }